var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHyperlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74374 5.85547L2.47266 5.85547C1.92037 5.85547 1.47266 6.30318 1.47266 6.85547V12.9973C1.47266 13.5496 1.92037 13.9973 2.47266 13.9973H8.61446C9.16675 13.9973 9.61446 13.5496 9.61446 12.9973V10.7859",
    stroke: "#F5F1EE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92285 10.8115L11.7168 4.01758M11.7168 4.01758V7.50071M11.7168 4.01758H8.46268",
    stroke: "#F5F1EE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlink);
export default __webpack_public_path__ + "static/media/hyperlink.aabcc632e2b568727f1a9a5876e3aaba.svg";
export { ForwardRef as ReactComponent };